/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const HeaderDetectionAlgorithm = core.serialization.enum_([
    "aiDetection",
    "default",
    "explicitHeaders",
    "specificRows",
    "dataRowAndSubHeaderDetection",
]);
